import React, { useState, useEffect } from 'react';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import './FeedCalculator.css';
// import jsPDF from 'jspdf';
import CalculatorReview from '../../components/CalculatorReview';
import { useSelector } from 'react-redux';
import { feedCalculation, fetchAnimalTypeByCategoryId, fetchBreedsByAnimalTypeId, fetchCalculatorReviewByReviewType, getTotalFeed } from '../../action/functions';
import ButtonFrame from '../../snippets/ButtonFrame';
import ToastMessage from '../../snippets/ToastMessage';
import SignInModal from '../../snippets/modal/SignInModal';
import SignUpModal from '../../snippets/modal/SignUpModal';
import useGoogleAnalytics from '../../action/useGoogleAnalytics';
import { FeedBagIcon } from '../../assets/IconSvg';


const FeedCalculator = () => {
  const trackEvent = useGoogleAnalytics("G-JKWGJ86LX7");
  const [loading, setLoading] = useState(false);
  const [animalType, setAnimalType] = useState(null);
  const [breedType, setBreedType] = useState([
    {
      id: "0",
      name: "Select Breed Category"
    }
  ]);
  const [breedSearchType, setBreedSearchType] = useState('breed');
  const [formData, setFormData] = useState({
    animal_type : '0',
    breed_type : '0',
    sub_breed_type : '0',
    min_age : 1,
    max_age : 1,
    total_animal: '',
    include_water: false
  })
  const [feedData, setFeedData] = useState(null);
  const [activeTab, setActiveTab] = useState('feed');
  const [hasReviewed, setHasReviewed] = useState(false);
  const [bagResultFormat, setBagResultFormat] = useState(true);

  const [isRatingModalOpen, setIsRatingModalOpen] = useState(false);

  const account = useSelector(state => state.account);

  const [isStartOpen, setIsStartOpen] = useState(true);

  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [isSignupModalOpen, setIsSignupModalOpen] = useState(false);


  const [msgAlert, setMsgAlert] = useState({
    active: false,
    message: "",
    status: "warning"
  });

  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_title: "Egg Calculator",
        page_location: window.location.href,
        page_path: "/feed-calculator", 
      });
    }
  }, []);

  useEffect(() => {
    if (animalType) return;
    (async() => {
      let result = await fetchAnimalTypeByCategoryId(1);

      if (!result.status) {

        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }
      setAnimalType([{
        id: "0",
        name: "Select Poultry Type",
        selected: true
      }, ...result.data.data]);

    })();
  }, [animalType]);

  useEffect(() => {
    if (!account || !account.isAuthenticated) return;

    (async() => {
      let result = await fetchCalculatorReviewByReviewType(account.token, 2);

      if (!result.status) {

        setMsgAlert({
          active: true,
          message: result.message,
          status: "error"
        });
        return;
      }

      if (result.data.data.review.length > 0) {
        setHasReviewed(true);
      }else {
        setHasReviewed(false);
      }

    })();
  }, [account]);

  useEffect(() => {
    if (activeTab === 'feed-result') {
      const timer = setTimeout(() => {
        if (hasReviewed) return;
        setIsRatingModalOpen(true);
      }, 30000); 

      return () => clearTimeout(timer);
    }
  }, [activeTab, hasReviewed]);

  const closeRatingModal = () => {
    setIsRatingModalOpen(false);
  }

  const handleBack = () => {
    setActiveTab('feed');
  };

  const handleFormChange = (evt, name) => {
    setFormData({...formData, [name]:evt.target.value});
  }

  const handleAnimalChange = async (evt) => {
    handleFormChange(evt, 'animal_type');
    let result = await fetchBreedsByAnimalTypeId(evt.target.value);
    
    if (!result.status) {
      alert(result.message);
      return;
    }

    setBreedType([
      {
        id: "0",
        name: "Select Breed Category"
      },
      ...result.data.data.breed
    ]);
    setBreedSearchType(result.data.data.search_type);
  }

  const getFormattedDate = () => {
    const today = new Date();
    const options = { day: 'numeric', month: 'short', year: 'numeric' };
    return today.toLocaleDateString('en-GB', options).replace(',', '.');
  };

  const openSignInModal = () => {
    setIsSignInModalOpen(true);
    setIsSignupModalOpen(false);
  };

  const closeSignInModal = () => {
    setIsSignInModalOpen(false);
  };

  const openSignupModal = () => {
    setIsSignInModalOpen(false);
    setIsSignupModalOpen(true);
  };

  const closeSignupModal = () => {
    setIsSignupModalOpen(false);
  };

  // const downloadAsPDF = () => {
  //   const feedWatermark = document.querySelector('.watermark-image');
  //   const feedResultHeader = document.querySelector('.feed-result-header');
  //   const feedResultLogoHeader = document.querySelector('.feed-result-logo-header');
  //   const feedActionsBtn = document.querySelector('.feed-actions');
  //   const fetchSocial = document.querySelector('.feed-result-social-container');
  //   const fetchEdit = document.querySelector('.feed-edit-button');

  //   if (feedResultHeader && feedResultLogoHeader && (account && account.isAuthenticated)) {

  //     feedResultHeader.style.display = 'none';
  //     feedActionsBtn.style.display = 'none';
  //     fetchEdit.style.display = 'none';
  //     feedResultLogoHeader.style.display = 'flex';
  //     fetchSocial.style.display = 'flex';
  //     feedWatermark.style.display = 'flex';

  //     html2canvas(document.querySelector('.feed-result-container'), { scale: 2 }).then((canvas) => {
  //       const imgData = canvas.toDataURL('image/png');
  //       const imgWidth = 210; 
  //       const pageHeight = 297;
  //       const imgHeight = (canvas.height * imgWidth) / canvas.width;

  //       const pdf = new jsPDF('p', 'mm', 'a4');
  //       let yPosition = 10;

  //       if (imgHeight <= pageHeight) {
  //         pdf.addImage(imgData, 'PNG', 0, yPosition, imgWidth, imgHeight);
  //       } else {
  //         let remainingHeight = imgHeight;
  //         let srcY = 0; 

  //         while (remainingHeight > 0) {
  //           const cropHeight = Math.min(remainingHeight, pageHeight - 10);
  //           const croppedCanvas = document.createElement('canvas');
  //           croppedCanvas.width = canvas.width;
  //           croppedCanvas.height = (cropHeight * canvas.width) / imgWidth;

  //           const croppedCtx = croppedCanvas.getContext('2d');
  //           croppedCtx.drawImage(
  //             canvas,
  //             0,
  //             srcY,
  //             canvas.width,
  //             croppedCanvas.height,
  //             0,
  //             0,
  //             croppedCanvas.width,
  //             croppedCanvas.height
  //           );

  //           const croppedImg = croppedCanvas.toDataURL('image/png');
  //           pdf.addImage(croppedImg, 'PNG', 0, yPosition, imgWidth, cropHeight);

  //           remainingHeight -= cropHeight;
  //           srcY += croppedCanvas.height;

  //           if (remainingHeight > 0) {
  //             pdf.addPage();
  //           }
  //         }
  //       }

  //       pdf.save(`Feed result_${getFormattedDate()}_${account.fullname.split(" ")[0]}.pdf`);

  //       feedResultHeader.style.display = 'flex';
  //       feedActionsBtn.style.display = 'flex';
  //       fetchEdit.style.display = 'flex';
  //       feedResultLogoHeader.style.display = 'none';
  //       fetchSocial.style.display = 'none';
  //       feedWatermark.style.display = 'none';
  //     });
  //   }
  // };

  const calculateFeed = async () => {
    if (!account || !account.isAuthenticated) return;
    
    if (formData.animal_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Poultry type is required',
        status: "warning"
      });
      return null;
    }

    if (breedSearchType === 'breed' && formData.breed_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Breed category is required',
        status: "warning"
      });
      return null;
    }

    if (breedSearchType !== 'breed' && formData.sub_breed_type === "0") {
      setMsgAlert({
        active: true,
        message: 'Sub breed category is required',
        status: "warning"
      });
      return null;
    }

    formData.include_water = formData.include_water ? 1 : 0;

    if (breedSearchType === 'breed') {
      delete formData.sub_breed_type;
    }else {
      delete formData.breed_type;
    }

    setLoading(true);
    let result = await feedCalculation(account.token, formData);

    if (result.status) {
      setFeedData(result.data.data);
      setActiveTab('feed-result');
      trackEvent("feed_calculator_button");
    }else {

      setMsgAlert({
        active: true,
        message: result.message,
        status: "error"
      });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (activeTab === "feed-result") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [activeTab]);



  return (
    <>
      <Navbar />
      {(!account || !account.isAuthenticated) && (
        <div className='email-popup-container'>
          <div className='check-email-popup'>
            <div className='email-popup-header'>
              <img src="/assets/carbon_email.svg" alt="Email Icon" className='email-popup-icon'/>
              <p className='email-popup-text'>Sign in / Sign up to use calculator</p>
            </div>
          </div>        
        </div>
      )}

      <div className="feed-calculator-container">
        <div className={`feed-calculator-header-container ${activeTab === 'feed-result' ? 'hidden' : ''}`}>
          <div className="feed-calculator-header">
            <img src="/assets/hay.png" alt="hay"/>
            <h1>Feed Calculator</h1>
          </div>
          <p className='feed-header-desc-mobile'>Calculate how much feed & water your flock requires, including timeline for different feed types and daily servings.</p>

          <div className='feed-calculator-tabs-container'>
            <p>Calculate how much feed & water your flock requires, including timeline for different feed types and daily servings.</p>
          </div>
        </div>

        <div className='feed-calculator-result'>
          {activeTab === 'feed' && (
            <div className="feed-calculator-card">

              {/* Poultry Type */}
              <div className="feed-input-container">
                <select
                  id="poultry-type"
                  value={formData.animal_type}
                  onChange={(e) => handleAnimalChange(e)}
                >
                  {animalType && animalType.map((type) => (
                    <option key={type.id} value={type.id}>{type.name}</option>  
                  ))}
                </select>
                <img src='/assets/dropdown_arrow.png' alt="arrow-down" style={{ cursor: 'pointer' }}/>
              </div>

              {/* Breed Category */}
              <div className="feed-input-container">
                <select
                  id="breed-category"
                  value={breedSearchType === 'breed' ? formData.breed_type : formData.sub_breed_type}
                  onChange={(e) => handleFormChange(e, `${breedSearchType === 'breed' ? "breed_type" : "sub_breed_type"}`)}
                >
                  {breedType && breedType.map((type) => (
                    <option key={type.id} value={type.id}>{type.name}</option>  
                  ))}
                </select>
                <img src='/assets/dropdown_arrow.png' alt="arrow-down" />
              </div>

              {/* Birds Count */}
              <div className="feed-input-container">
                <label htmlFor="bird-count">How many birds are you calculating for?</label>
                <input
                  type="number"
                  id="birds-count"
                  value={formData.total_animal}
                  placeholder='0'
                  onChange={(e) => handleFormChange(e, 'total_animal')}
                  onFocus={(e) => { e.target.placeholder = ''}}
                  onBlur={(e) => { e.target.placeholder = '0' }}
                  required
                />
              </div>
              {isStartOpen && (
                <div className='start-age-content'>
                  <div className='start-title-container'>
                    <h3 className='start-end-title'>Start/End Age</h3>
                    <img src='/assets/close.png' alt='close icon' className='start-close-icon' onClick={() => setIsStartOpen(false)}/>
                  </div>
                  <div className='start-age-container'>
                    <p className='start-end-age-text'><strong>Start Age:</strong> The age at which you  wish to begin feeding your birds. e.g 1 Week represents day 1 - 7.</p>
                    <p className='start-end-age-text'><strong>End Age:</strong> The age at which you wish to stop feeding your birds.</p>
                  </div>
                </div>
              )}

              {/*Start and End date*/}
              <div className="feed-inputs-container">
                <div className="feed-input-container">
                  <div className='feed-label-wrapper'>
                    <label>Start Age (Weeks)</label>
                    {/* <img src="/assets/question-fill.png" alt="question mark" className='feed-question-mark'/> */}
                  </div>
                  <div className="feed-input-wrapper">
                    <input
                      type="number"
                      id="start-age"
                      value={formData.min_age}
                      onChange={(e) => handleFormChange(e, 'min_age')}
                      required
                    />
                    <span className="feed-unit">wk</span>
                  </div>
                </div>

                <div className="feed-input-container">
                  <div className='feed-label-wrapper'>
                    <label>End Age (Weeks)</label>
                    {/* <img src="/assets/question-fill.png" alt="question mark" className='feed-question-mark'/> */}
                  </div>
                  <div className="feed-input-wrapper">
                    <input
                      type="number"
                      id="end-date"
                      value={formData.max_age}
                      onChange={(e) => handleFormChange(e, 'max_age')}
                      required
                    />
                    <span className="feed-unit">wk</span>
                  </div>
                </div>
              </div>

              {/*Water Info */}
              <div className="checkbox-container">
                <input 
                  type="checkbox" 
                  id="include-water"
                  checked={formData.include_water}
                  onChange={(e) => setFormData({...formData, include_water:!formData.include_water})} 
                />
                <label htmlFor="include-water">Include water information</label>
              </div>

              {account && account.isAuthenticated ? (
                <ButtonFrame handleClick={calculateFeed} loading={loading} btnText={"Calculate"} classNameStyle="feed-calculate-btn" />
              ): (
                <ButtonFrame handleClick={() => openSignInModal()} loading={loading} btnText={"Login to access calculator"} classNameStyle="feed-calculate-btn" />
              )}
            </div>
          )}

          {feedData && activeTab === 'feed-result' && (
            <div className="feed-result-container">
              <header className="feed-result-header">
                <img src="/assets/form-next.png" alt="next arrow" className="feed-back-button" onClick={handleBack}/>
                <h1>Feed Result</h1>
                <img src="/assets/send_icon.svg" alt="send icon" className="feed-send-button"/>
              </header>

              <header className="feed-result-logo-header">
                <img src="/assets/rairer-logo.svg" alt="raier logo" className="feed-result-logo"/>
                <div className='feed-date-container'>
                  <h4>My Feed</h4>
                  <p>{getFormattedDate()}</p>
                </div>
              </header>

              {/* Chicken Details */}
              <div className="feed-bird-card">
                <div className="feed-card-header">
                  <div className='feed-icon-wrapper-container'>
                    <div className="feed-icon-wrapper">
                      <img src="/assets/chicken.png" alt="Chicken Icon" />
                    </div>
                    <h2>{formData.total_animal} {feedData.feed.poultry}</h2>
                  </div>
                  <button className="feed-edit-button" onClick={handleBack}>Edit</button>
                </div>

                <div className="feed-card-body">
                  <div className='feed-info-container'>
                    <img src="/assets/feather_small.svg" alt="feather" className='feed-info-img'/>
                    <div className="feed-info">
                      <span className="feed-info-label">Breed Type</span>
                      <p>{feedData.feed.breed}</p>
                    </div>
                  </div>
                  <div className='feed-info-container'>
                    <img src="/assets/rearing-duration.svg" alt="rearing icon" className='feed-info-img'/>
                    <div className="feed-info">
                      <span className="feed-info-label">Rearing Duration</span>
                      <p>{parseInt(formData.min_age) === 0 ? "Day 1" : `Week ${formData.min_age}`} - Week {formData.max_age}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Feed Estimate */}
              <div className="feed-card feed-estimate-card">
                <div className="feed-title-header feed-toggle-header" style={{justifyContent:'center', marginBottom:20}}>
                  {/* <img src="/assets/feed-estimate-icon.svg" alt="Feed Icon"/>
                  <h2>Feed Estimate</h2> */}
                  <div className='toggleHeader'>
                    <button className={bagResultFormat ? "active" : ""} onClick={() => setBagResultFormat(true)}>Bags (Kg)</button>
                    <button className={!bagResultFormat ? "active" : ""} onClick={() => setBagResultFormat(false)}>Volume (Kg)</button>
                  </div>
                </div>
                {/* <div className='feed-card-divider'></div> */}
                {bagResultFormat && (
                  <div className='feed-toggle-header'>
                    <div className='feed_bag_format'>
                      <span>
                        <FeedBagIcon />
                      </span>
                      1 Bag = 25kg
                    </div>
                  </div>
                )}
                
                <div className="feed-estimate-body">
                  {feedData.feed_breakdown.map((feed, index) => (
                    <div key={index} className='feed-item-container'>
                      <div className="feed-item">
                        <div className='feed-item-title-container'>
                          <p className='feed-item-title'>{feed.feed_name}</p>
                          <div className={`feed-total-weight ${index === 0 ? "feed-starter" : ((index + 1) % 2 === 0 ? "feed-grower" : "feed-finisher")}`}><p>{getTotalFeed(feed.total_feeds, bagResultFormat)}</p></div>
                        </div>
                        <div className='feed-meta'>
                          <p className="feed-duration spanned">{feed.min_age === 0 ? "Day 1" : `Week ${feed.min_age}`} - Week {feed.max_age}</p>
                          <p className="feed-duration spanned" style={{opacity: bagResultFormat ? 0.5 : 1}}>({feed.feed_per_animal}kg/Bird)</p>
                        </div>
                        
                      </div>
                      {/* <span>({feed.feed_per_animal}kg/Bird)</span> */}
                    </div>
                  ))}
                </div>
                <div className='feed-card-divider'></div>
                <p className='feed-note'><span className='feed-note-heading'>Note:</span>  Estimates may vary slightly depending on specific breeds, feed quality, and poultry farm management.</p>
                <img src='/assets/rairer-calculator-watermark.svg' alt="watermark" className='watermark-image'/>
              </div>

              {/* Water Estimate */}
              {feedData.water_breakdown && (
                <div className="feed-card water-estimate-card">
                  <div className="feed-title-header">
                    <img src="/assets/water-estimate.svg" alt="water Icon"/>
                    <h2>Water Estimate</h2>
                  </div>
                  <div className='feed-card-divider'></div>
                  <div className="feed-item feed-water-item">
                    <div className='feed-water-title-container'>
                      <p className='feed-item-title'>{feedData.water_breakdown.sum_water_amount} Litres</p>
                      {/* <span>({feedData.water_breakdown.water_amount_per_bird * 1000}ml/Bird)</span> */}
                    </div>
                    <div className='feed-meta'>
                      <p className="feed-duration spanned">{parseInt(formData.min_age) === 0 ? "Day 1" : `Week ${formData.min_age}`} - Week {formData.max_age}</p>
                      <p className="feed-duration spanned">({feedData.water_breakdown.water_amount_per_bird * 1000}ml/Bird)</p>
                    </div>
                  </div>
                  <div className='feed-card-divider'></div>
                  <p className='feed-note'><span className='feed-note-heading'>Note:</span> Water consumption is influenced by temperature, 
                    humidity, and feed type. Therefore, your bird may require more than estimated in varying conditions.</p>
                  <img src='/assets/rairer-calculator-watermark.svg' alt="watermark" className='watermark-image'/>
                </div>
              )}

              <div className='feed-result-social-container'>
                <p>@rairerapp</p>
                <div className='feed-social-container'>
                  <img src='/assets/facebook-color.svg' alt='Facebook Icon'/>
                  <img src='/assets/twitter-color.svg' alt='Twitter Icon'/>
                  <img src='/assets/instagram-color.svg' alt='Instagram Icon'/>
                  <img src='/assets/linkedin-color.svg' alt='LinkedIn Icon'/>
                </div>
              </div>

              {/* Download btn */}
              {/* <div className='feed-actions' onClick={downloadAsPDF}>
                <div className='feed-action-btn-container'>
                  <img src="/assets/download-outline.png" alt="download icon"/>
                  <button className="feed-action-button" onClick={downloadAsPDF}>Download</button>
                </div>
              </div> */}
            </div>
          )}
        </div>
      </div>
      <Footer/>
      {(account && account.isAuthenticated) && isRatingModalOpen && (
        <CalculatorReview account={account} reviewType={{
          id: 2,
          name: "Feed"
        }} closeRatingModal={closeRatingModal}/>
      )}

      {isSignInModalOpen && (
        <SignInModal closeSignIn={closeSignInModal} openSignUp={openSignupModal} onSubmit={closeSignInModal}  />
      )}

      {isSignupModalOpen && (
        <SignUpModal closeSignup={closeSignupModal} openSignIn={openSignInModal} onSubmit={closeSignupModal} />
      )}

      {msgAlert.active && <ToastMessage toastTitle={"Feed Calculator"} toastMessage={msgAlert.message} toastType={msgAlert.status} closeOut={() => setMsgAlert({...msgAlert, active:false})} />}
    </>
  );
};

export default FeedCalculator;
